import { render } from "./SplashScreen.vue?vue&type=template&id=524ecf4e"
const script = {}

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__